import { useDispatch, useSelector } from "react-redux";
import { selectSearch } from "../../../modules/search/selectors";
import { receivePurposeRequest,clearPurpose } from '../../../modules/search/actions/search';

export type PurposeOption = {
  id: number;
  value: string;
};

export type PurposesState = {
  items: PurposeOption[];
  loading: boolean;
  error: string | null;
  lastQuery: string;
}

export const usePurposes = () => {
  const dispatch = useDispatch();
  const { purposesResult, purposesLoading, purposesError, purposesLastQuery } = useSelector(selectSearch);

  const suggest = (inputValue: string) => {
     dispatch(receivePurposeRequest({inputValue}));
  };

  const clear = () => {
    dispatch(clearPurpose());
  };

  return {
    options: purposesResult as PurposeOption[],
    loading: purposesLoading,
    error: purposesError,
    lastQuery: purposesLastQuery,
    suggest,
    clear,
  }
}